<form [formGroup]="formData" novalidate (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group" *ngIf="!variant && !selectParent">
      <label for="">Parent SKU:</label>
      <input class="form-control" type="text" formControlName="parent_sku" />
    </div>
    <div class="form-group col-12 px-0" *ngIf="selectParent">
      <label for="">Search Parent SKU</label>
      <div class="input-group">
        <ng-select
          [items]="rfq$ | async"
          [addTag]="false"
          [multiple]="false"
          class="flex-fill"
          [hideSelected]="true"
          [trackByFn]="trackByFn"
          [loading]="rfqLoading"
          [typeahead]="rfqInput$"
          (change)="onSelectParent(parent)"
          [(ngModel)]="parent"
          name="rfqProduct"
          appendTo="body"
          formControlName="parent_sku"
        >
          <ng-template ng-label-tmp let-item="item">
            [{{ item.internal_sku }}] {{ item.product_name }}
          </ng-template>
          <ng-template
            ng-option-tmp
            let-item="item"
            let-index="index"
            let-search="searchTerm"
          >
            [{{ item.internal_sku }}] {{ item.product_name }}
          </ng-template>
        </ng-select>
      </div>
    </div>

    <ng-container *ngIf="parent || variant">
      <div class="form-group">
        <label for="">Variant SKU:</label>
        <input class="form-control" type="text" formControlName="internal_sku" />
        <control-messages
          [submitted]="submitted"
          [control]="formData.controls.internal_sku"
        >
        </control-messages>
      </div>
      <div class="form-group">
        <label for="">Product Name:</label>
        <input class="form-control" type="text" formControlName="product_name" />
        <control-messages
          [submitted]="submitted"
          [control]="formData.controls.product_name"
        >
        </control-messages>
      </div>

      <div class="form-group">
        <div class="row">
          <div class="col-md-6">
            <label for="">Wholesale Price:</label>
            <input
              class="form-control"
              type="number"
              formControlName="wholesale_price"
            />
            <control-messages
              [submitted]="submitted"
              [control]="formData.controls.wholesale_price"
            >
            </control-messages>
          </div>
          <div class="col-md-6">
            <label for="">Retail Price:</label>
            <input
              class="form-control"
              type="number"
              formControlName="retail_price"
            />
            <control-messages
              [submitted]="submitted"
              [control]="formData.controls.retail_price"
            >
            </control-messages>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- 
        <div class="overflow-auto ">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Incoming Qty</th>
                        <th>Onhand Qty</th>
                        <th>Pending Qty</th>
                        <th>Available Qty</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <input type="number" class="form-control text-right" formControlName="qty_incoming" />
                        </td>
                        <td>
                            <input type="number" class="form-control text-right" formControlName="qty_onhand" />
                        </td>
                        <td>
                            <input type="number" class="form-control text-right" formControlName="qty_pending" />
                        </td>
                        <td>
                            <input type="number" class="form-control text-right" formControlName="qty_available"/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
         -->
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="activeModal.dismiss('')">
      <i class="fas fa-times"></i> Close
    </button>
    <button
      type="submit"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
      [disabled]="loading"
      id="kt_submit"
      class="btn btn-primary btn-elevate kt-btn-primary"
      [translate]="'BUTTONS.SAVE'"
    >
      <i class="fas fa-save"></i> Save
    </button>
  </div>
</form>
